const TLSYNC_PROTOCOL_VERSION = 7;
function getTlsyncProtocolVersion() {
  return TLSYNC_PROTOCOL_VERSION;
}
const TLIncompatibilityReason = {
  ClientTooOld: "clientTooOld",
  ServerTooOld: "serverTooOld",
  InvalidRecord: "invalidRecord",
  InvalidOperation: "invalidOperation"
};
export {
  TLIncompatibilityReason,
  getTlsyncProtocolVersion
};
//# sourceMappingURL=protocol.mjs.map
